
(function() {
  'use strict';

  var COLOR_MAP = {
    'navy-blue-pick-pick-suit': { name: 'Navy', color: '#1b2a4a' },
    'grey-pick-pick-suit': { name: 'Grey', color: '#8a8a8a' },
    'charcoal-pick-pick-suit': { name: 'Charcoal', color: '#3d3d3d' }
  };
  var COLORS_ORDER = ['navy-blue-pick-pick-suit', 'grey-pick-pick-suit', 'charcoal-pick-pick-suit'];

  function getCurrentHandle() {
    var path = window.location.pathname;
    var match = path.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : '';
  }

  function sortSizes(values) {
    return values.slice().sort(function(a, b) {
      var numA = parseInt(a, 10), numB = parseInt(b, 10);
      if (!isNaN(numA) && !isNaN(numB) && numA !== numB) return numA - numB;
      return a.localeCompare(b);
    });
  }

  function init() {
    var variantPicker = document.querySelector('variant-picker') || document.querySelector('[class*="variant-picker"]');
    if (!variantPicker) { setTimeout(init, 200); return; }

    var selects = variantPicker.querySelectorAll('select');
    if (selects.length < 3) { setTimeout(init, 200); return; }

    var jacketSelect = selects[0];
    var waistSelect = selects[1];
    var inseamSelect = selects[2];

    variantPicker.style.display = 'none';

    var container = document.createElement('div');
    container.id = 'cs-custom-picker';

    // === COLOR SWATCHES ===
    var currentHandle = getCurrentHandle();
    var swatchSection = document.createElement('div');
    swatchSection.className = 'cs-color-section';

    var colorLabel = document.createElement('div');
    colorLabel.className = 'cs-color-label';
    colorLabel.textContent = COLOR_MAP[currentHandle] ? COLOR_MAP[currentHandle].name : 'Color';
    swatchSection.appendChild(colorLabel);

    var swatchRow = document.createElement('div');
    swatchRow.className = 'cs-swatch-row';

    COLORS_ORDER.forEach(function(handle) {
      var info = COLOR_MAP[handle];
      var swatch = document.createElement('a');
      swatch.className = 'cs-swatch' + (handle === currentHandle ? ' cs-swatch--active' : '');
      swatch.href = '/products/' + handle;
      swatch.title = info.name;
      swatch.style.backgroundColor = info.color;
      swatchRow.appendChild(swatch);
    });

    swatchSection.appendChild(swatchRow);
    container.appendChild(swatchSection);

    // === JACKET SIZE BOX ===
    var jacketSizes = [];
    for (var i = 0; i < jacketSelect.options.length; i++) {
      if (jacketSelect.options[i].value) jacketSizes.push(jacketSelect.options[i].value);
    }
    jacketSizes.sort(function(a, b) {
      var numA = parseInt(a, 10), numB = parseInt(b, 10);
      if (numA !== numB) return numA - numB;
      var order = { S: 0, R: 1, L: 2 };
      return (order[a.replace(/[0-9]/g, '')] || 0) - (order[b.replace(/[0-9]/g, '')] || 0);
    });

    var jacketBox = createSizeBox('Select Your Jacket Size', 'cs-jacket-box', jacketSizes, function(val) {
      jacketSelect.value = val;
      jacketSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('.cs-box-label').textContent = 'Jacket Size: ' + val;
      this.classList.remove('cs-box--open');
      this.classList.add('cs-box--selected');
    });
    container.appendChild(jacketBox);

    // === PANTS SIZE BOX ===
    var pantsBox = createPantsBox(waistSelect, inseamSelect);
    container.appendChild(pantsBox);

    variantPicker.parentNode.insertBefore(container, variantPicker);

    // === DESCRIPTION + DETAILS (below Add to Cart) ===
    injectDescription();
    injectEstimatedArrival();
  }

  function injectDescription() {
  var handle = getCurrentHandle();
  if (!handle) return;
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/products/' + handle + '.json', false);
  xhr.send();
  if (xhr.status !== 200) return;
  var product = JSON.parse(xhr.responseText).product;
  var html = product.body_html;
  if (!html || html.trim() === '') return;

  // Parse HTML into a temp container to split on h4 headers
  var temp = document.createElement('div');
  temp.innerHTML = html;

  var sections = [];
  var currentTitle = 'Description';
  var currentContent = '';

  var children = temp.childNodes;
  for (var i = 0; i < children.length; i++) {
    var node = children[i];
    if (node.nodeName === 'H4') {
      // Save current section
      if (currentContent.trim()) {
        sections.push({ title: currentTitle, html: currentContent });
      }
      currentTitle = node.textContent.trim();
      currentContent = '';
    } else {
      if (node.outerHTML) {
        currentContent += node.outerHTML;
      } else if (node.textContent && node.textContent.trim()) {
        currentContent += node.textContent;
      }
    }
  }
  // Push last section
  if (currentContent.trim()) {
    sections.push({ title: currentTitle, html: currentContent });
  }

  // Also add a hardcoded Shipping & Returns if not already present
  var hasShipping = sections.some(function(s) {
    return s.title.toLowerCase().indexOf('shipping') !== -1;
  });
  if (!hasShipping) {
    sections.push({
      title: 'Shipping & Returns',
      html: '<p>Free standard shipping on all orders. Free returns within 30 days of delivery.</p>'
    });
  }

  // Size Guide accordion (always last, after Free Shipping)
  sections.push({
    title: 'Size Guide',
    html: '<img src="https://cdn.shopify.com/s/files/1/0994/0133/5077/files/size-guide-chart.png?v=1781281175" alt="Size guide chart" style="max-width:100%;height:auto;display:block">' +
      '<p>Standard US sizing &middot; body measurements in inches. <a href="/pages/size-guide">View the full size guide</a>.</p>'
  });

  // Find insertion point (after buy buttons)
  var buyBtn = document.querySelector('.product-form__submit') || document.querySelector('button[name="add"]');
  if (!buyBtn) return;
  var formEl = buyBtn.closest('form') || buyBtn.parentElement;
  var insertAfter = formEl.parentElement;

  var container = document.createElement('div');
  container.id = 'cs-description-accordions';
  container.style.marginTop = '24px';

  for (var j = 0; j < sections.length; j++) {
    var acc = createAccordion(sections[j].title, sections[j].html, j === 0);
    container.appendChild(acc);
  }

  insertAfter.parentElement.insertBefore(container, insertAfter.nextSibling);
}

function injectEstimatedArrival() {
  if (document.getElementById('cs-estimated-arrival')) return;

  var delivery = window.CS_DELIVERY;
  if (!delivery) return;
  var minDays = Number(delivery.min);
  var maxDays = Number(delivery.max);
  if (!(minDays > 0) || !(maxDays > 0)) return;

  var today = new Date();
  var minDate = new Date(today.getTime());
  minDate.setDate(minDate.getDate() + minDays);
  var maxDate = new Date(today.getTime());
  maxDate.setDate(maxDate.getDate() + maxDays);

  function formatDate(date) {
    var formatted = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    if (date.getFullYear() !== today.getFullYear()) {
      formatted += ', ' + date.getFullYear();
    }
    return formatted;
  }

  var div = document.createElement('div');
  div.id = 'cs-estimated-arrival';
  div.style.fontSize = '0.85rem';
  div.style.letterSpacing = '0.02em';
  div.style.color = '#555';
  div.style.marginTop = '12px';
  div.innerHTML = 'Estimated arrival: <strong style="color:#111;font-weight:600">' + formatDate(minDate) + ' – ' + formatDate(maxDate) + '</strong>';

  // Insert after the buy buttons / customizer area, before the description accordions
  var accordions = document.getElementById('cs-description-accordions');
  if (accordions) {
    accordions.parentElement.insertBefore(div, accordions);
    return;
  }
  var buyBtn = document.querySelector('.product-form__submit') || document.querySelector('button[name="add"]');
  if (!buyBtn) return;
  var formEl = buyBtn.closest('form') || buyBtn.parentElement;
  var insertAfter = formEl.parentElement;
  insertAfter.parentElement.insertBefore(div, insertAfter.nextSibling);
}

function createAccordion(title, contentHTML, openByDefault) {
  var wrapper = document.createElement('div');
  wrapper.className = 'cs-accordion' + (openByDefault ? ' cs-accordion--open' : '');

  var header = document.createElement('button');
  header.className = 'cs-accordion-header';
  header.innerHTML = '<span>' + title.toUpperCase() + '</span><span class="cs-accordion-icon">+</span>';

  var body = document.createElement('div');
  body.className = 'cs-accordion-body';
  body.innerHTML = contentHTML;

  header.addEventListener('click', function() {
    var isOpen = wrapper.classList.contains('cs-accordion--open');
    wrapper.classList.toggle('cs-accordion--open');
    header.querySelector('.cs-accordion-icon').textContent = isOpen ? '+' : '\u2212';
  });

  // Set initial icon
  if (openByDefault) {
    header.querySelector('.cs-accordion-icon').textContent = '\u2212';
  }

  wrapper.appendChild(header);
  wrapper.appendChild(body);
  return wrapper;
}
function createSizeBox(title, id, sizes, onSelect) {
    var box = document.createElement('div');
    box.className = 'cs-size-box';
    box.id = id;

    var header = document.createElement('div');
    header.className = 'cs-box-header';
    header.innerHTML = '<span class="cs-box-label">' + title + '</span><span class="cs-box-chevron">&rsaquo;</span>';
    header.addEventListener('click', function() {
      box.classList.toggle('cs-box--open');
      var other = box.parentNode.querySelector('.cs-size-box.cs-box--open:not(#' + id + ')');
      if (other) other.classList.remove('cs-box--open');
    });
    box.appendChild(header);

    var panel = document.createElement('div');
    panel.className = 'cs-box-panel';

    var grid = document.createElement('div');
    grid.className = 'cs-size-grid';

    sizes.forEach(function(size) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-size-btn';
      btn.textContent = size;
      btn.addEventListener('click', function() {
        grid.querySelectorAll('.cs-size-btn').forEach(function(b) { b.classList.remove('cs-size-btn--active'); });
        btn.classList.add('cs-size-btn--active');
        onSelect.call(box, size);
      });
      grid.appendChild(btn);
    });

    panel.appendChild(grid);
    box.appendChild(panel);
    return box;
  }

  function createPantsBox(waistSelect, inseamSelect) {
    var box = document.createElement('div');
    box.className = 'cs-size-box';
    box.id = 'cs-pants-box';

    var selectedWaist = '';
    var selectedInseam = '';

    var header = document.createElement('div');
    header.className = 'cs-box-header';
    header.innerHTML = '<span class="cs-box-label">Select Your Pants Size</span><span class="cs-box-chevron">&rsaquo;</span>';
    header.addEventListener('click', function() {
      box.classList.toggle('cs-box--open');
      var other = box.parentNode.querySelector('.cs-size-box.cs-box--open:not(#cs-pants-box)');
      if (other) other.classList.remove('cs-box--open');
    });
    box.appendChild(header);

    var panel = document.createElement('div');
    panel.className = 'cs-box-panel';

    // Waist
    var waistLabel = document.createElement('div');
    waistLabel.className = 'cs-panel-sublabel';
    waistLabel.textContent = 'WAIST';
    panel.appendChild(waistLabel);

    var waistValues = [];
    for (var i = 0; i < waistSelect.options.length; i++) {
      if (waistSelect.options[i].value) waistValues.push(waistSelect.options[i].value);
    }
    waistValues = sortSizes(waistValues);

    var waistGrid = document.createElement('div');
    waistGrid.className = 'cs-size-grid';
    waistValues.forEach(function(val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-size-btn';
      btn.textContent = val;
      btn.addEventListener('click', function() {
        waistGrid.querySelectorAll('.cs-size-btn').forEach(function(b) { b.classList.remove('cs-size-btn--active'); });
        btn.classList.add('cs-size-btn--active');
        selectedWaist = val;
        waistSelect.value = val;
        waistSelect.dispatchEvent(new Event('change', { bubbles: true }));
        updatePantsLabel();
      });
      waistGrid.appendChild(btn);
    });
    panel.appendChild(waistGrid);

    // Inseam
    var inseamLabel = document.createElement('div');
    inseamLabel.className = 'cs-panel-sublabel';
    inseamLabel.textContent = 'INSEAM';
    panel.appendChild(inseamLabel);

    var inseamValues = [];
    for (var j = 0; j < inseamSelect.options.length; j++) {
      if (inseamSelect.options[j].value) inseamValues.push(inseamSelect.options[j].value);
    }
    inseamValues = sortSizes(inseamValues);

    var inseamGrid = document.createElement('div');
    inseamGrid.className = 'cs-size-grid';
    inseamValues.forEach(function(val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-size-btn';
      btn.textContent = val;
      btn.addEventListener('click', function() {
        inseamGrid.querySelectorAll('.cs-size-btn').forEach(function(b) { b.classList.remove('cs-size-btn--active'); });
        btn.classList.add('cs-size-btn--active');
        selectedInseam = val;
        inseamSelect.value = val;
        inseamSelect.dispatchEvent(new Event('change', { bubbles: true }));
        updatePantsLabel();
      });
      inseamGrid.appendChild(btn);
    });
    panel.appendChild(inseamGrid);

    box.appendChild(panel);

    function updatePantsLabel() {
      var label = header.querySelector('.cs-box-label');
      if (selectedWaist && selectedInseam) {
        label.textContent = 'Pants: W' + selectedWaist + ' / L' + selectedInseam;
        box.classList.remove('cs-box--open');
        box.classList.add('cs-box--selected');
      } else if (selectedWaist) {
        label.textContent = 'Pants: W' + selectedWaist + ' \u2014 select inseam';
      } else if (selectedInseam) {
        label.textContent = 'Pants: L' + selectedInseam + ' \u2014 select waist';
      }
    }

    return box;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
